import { useThemeContext } from '../contexts/ThemeContext';

type ToastStyle = {
  backgroundColor: string;
  color: string;
};
export const useToastStyle = () => {
  // Context
  const theme = useThemeContext();
  const toastStyle: ToastStyle = {
    backgroundColor: theme === 'dark' ? '#22252a' : '',
    color: theme === 'dark' ? '#ccc' : '',
  };
  return toastStyle;
};
